import { Button, Popconfirm, Popover } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ExportFile = ({
  disabled,
  onClick,
  isIconAndText = true,
  className = 'mr-5',
  buttonText,
}: {
  disabled: boolean;
  isIconAndText?: boolean;
  buttonText?: string;
  onClick?: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Popconfirm
      title={t('hint.downloadTitle')}
      description={t('hint.downDescrip')}
      okText={t('confirm')}
      disabled={disabled}
      cancelText={t('cancel')}
      onConfirm={() => {
        onClick?.();
      }}
    >
      <Popover content={<p>{t('export')}</p>} title="">
        {isIconAndText ? (
          <Button
            className={className}
            type="primary"
            icon={<UploadOutlined style={{ fontSize: 15 }} />}
          >
            {buttonText || t('export')}
          </Button>
        ) : (
          <Button
            color="default"
            icon={
              <UploadOutlined
                className="text-[#666] dark:text-[#ffffffd9]"
                style={{ fontSize: 20 }}
              />
            }
            variant="link"
          />
        )}
      </Popover>
    </Popconfirm>
  );
};

export default ExportFile;
